<template>
	<div style="padding: 0px;">
		<el-form :inline="false" :model="loctypeinfo" :rules="rules" ref="sysconfigrule" label-width="120px" class="">
			<el-row>
				<el-col :span="10">
					<el-form-item label="名称" prop="name">
						<el-input clearable v-model="loctypeinfo.name" maxlength="30"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="10">
					<el-form-item label="编码" prop="code">
						<el-input clearable v-model="loctypeinfo.code" :disabled="disabled_cord" maxlength="30"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="20">
					<el-form-item label="排序" prop="idx">
						<el-input-number v-model="loctypeinfo.idx" :min="1" :max="999" :precision="2" :step="0.1" ></el-input-number>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<div style="text-align: center;">
			<el-button plain @click="closeDlg">取消</el-button>
			<el-button type="primary" @click="saveLocType">保存</el-button>
		</div>
	</div>
</template>

<script> 
	import { addLocType,editLocType } from '/static/apiUrl.js'
	export default {
		name : 'LocTypeDetail',
		data() {
			return {
				editok: false,
				disabled_cord: false,
				uploadheader : {
					Authorization: sessionStorage.getItem("authToken")
				},				
				loctypeinfo : {
					id: "",
					name: "",
					code: "",
					idx: "",
				},			
				rules:{
					name: [
						{ required: true, message: '请输入名称', trigger: 'blur' }
					],
					code: [
						{ required: true, message: '请输入编码', trigger: 'blur' }
					],
					idx: [
						{ required: true, message: '请输入排序', trigger: 'blur' }
					],
				}
			}
		},
		mounted() {
			
		},
		BeforeCreate(){
			
		},
		props: {
			selectconfig : {
				type: Object,
				required: false
			}
		},
		watch: {
			selectconfig: {
				immediate: true,
				handler(newVal) {
					this.clearData()
					if (newVal != null && newVal != "") {						
						this.disabled_cord = true
						this.loctypeinfo.id = newVal.id
						this.loctypeinfo.name = newVal.name
						this.loctypeinfo.code = newVal.code
						this.loctypeinfo.idx = newVal.idx
					}else{
						this.loctypeinfo.id = ''
						this.loctypeinfo.name = ''
						this.loctypeinfo.code = ''
						this.loctypeinfo.idx = 1
						this.disabled_cord = false
					}
				}
			},
		},
		methods: {
			clearData(){
				this.editok = false
				this.disabled_cord = false
			},
			closeDlg() {
				this.$emit("needRefrash",false,false)
			},
			saveLocType(){
				this.$refs["sysconfigrule"].validate((valid) => {
					if (valid) {
						if(this.loctypeinfo.id != null && this.loctypeinfo.id != ''){  //编辑
							editLocType(this.loctypeinfo).then(res => {
								if(0 == res.code){
									this.$emit("needRefrash",true,false)
									this.$message.success("修改位置类型成功")
								}else{
									this.$message.error(res.messge,true)
								}
							})
						}else{ //新增
							addLocType(this.loctypeinfo).then(res => {
								if(0 == res.code){
									this.clearData();
									this.$emit("needRefrash",true,false)
									this.$message.success("添加位置类型成功")
								}else{
									this.$message.error(res.messge)
								}
							})
						}
					} else {
						return false;
					}
				});
			},
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>